module.exports = __webpack_public_path__ + "img/rrp-logo.1604d8fa.png";